module.exports = "https://dev.stanwinstonschool.com/galaxyquest_poster_alt Large.b214fcdbf2215d9e8a5b311d7df745ef.jpeg";